import axios from "axios";
import router from "../router";

let Interceptor

export function removeInterceptor() {
  axios.interceptors.request.eject(Interceptor)
}

export function addInterceptor(){
  let errorCodes = [403, 405, 408, 409, 423, 413, 429, 500, 502, 503, 504];

  Interceptor = axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    let originalConfig = error.config;
    if (originalConfig.url.match(/^(.*\/geoservices\.wallonie\.be\/.*)|(.*\/geo\.api\.vlaanderen\.be\/.*)$/)) {
      console.log("An error occurred within the street service.")
      return Promise.reject(error)
    }
    else if (errorCodes.indexOf(error.response.status) != -1) {
      if(error.response.data.error === 'subscription has been confirmed, no modification allowed') {
        router.push({ name: "Confirmation" })
      } else if (error.response.data.error === "Can't confirm subscription as agent") {
        router.push({ name: "ServerError", query: { code: "450" } })
      } else if (error.response.status === 403) {
        router.push({ name: "ServerError", query: { code: "403" } })
      } else if (error.response.status === 423) {
        router.push({ name: "ServerError", query: { code: "423" } })
      } else {
        router.push({ name: "ServerError" })
      }
    }

    throw error;
  });
}



// WEBPACK FOOTER //
// ./src/services/interceptors.js